import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {IQueryByBankIdParams} from './useKnowledgeBank';
import {Moment} from 'moment';
import {IContest} from './useContest';

export enum KnowledgeTestStatusConfig {
  开启 = 1,
  关闭 = 2,
  自动 = 3,
}

export enum KnowledgeTestType {
  答题演练 = 1,
  正式答题 = 2,
}

export interface IKnowledgeTest {
  id: number;
  multiBankId: number;
  singleBankId: number;
  beginTime: string;
  endTime: string;
  bankId: number;
  singleAmount: number;
  singleScore: number;
  multiAmount: number;
  multiScore: number;
  statusConfig: KnowledgeTestStatusConfig;
  type: KnowledgeTestType;
  remark: string;
  timeLimit: number;
  contestId: number;
  contest: IContest;
  createdTime: string;
}

export interface IKnowledgeTestSaveParams {
  id: number;
  beginTime: string;
  endTime: string;
  singleBankId: number;
  singleAmount: number;
  singleScore: number;
  multiBankId: number;
  multiAmount: number;
  multiScore: number;
  timeLimit: number;
  statusConfig: KnowledgeTestStatusConfig;
  remark: string;
}

export interface IQueryByKnowledgeTestIdParams {
  testId: number;
}

export interface IKnowledgeTestQueryHistoryResponseItem {
  submitterId: number;
  submitter: IUser;
  count: number;
  totalScoreGet: number;
  averageScoreGet: number;
  bestScoreGet: number;
  bestTimeUsage: number;
  bestTimeUsageSubmissionId: number;
  submittedTime: string;
  beginTime: string;
}

export interface IKnowledgeTestQueryHistoryParams {
  testId: number;
  userId: number;
}

export interface KnowledgeTestExportReportResponse {
  url: string;
  list: IKnowledgeTestQueryHistoryResponseItem[];
}

export default class UseKnowledgeTest {
  static save() {
    return usePost<IKnowledgeTestSaveParams, IKnowledgeTest>('knowledgeTest/save', {});
  }
  static queryById() {
    return useGet<IQueryByIdParams, IKnowledgeTest>('knowledgeTest/queryById', {});
  }
  static queryHistoryByTestId() {
    return useGet<IKnowledgeTestQueryHistoryParams, IKnowledgeTestQueryHistoryResponseItem>('knowledgeTest/queryHistoryByTestId', {});
  }
  static queryHistory() {
    return useGet<IQueryByKnowledgeTestIdParams, IKnowledgeTestQueryHistoryResponseItem[]>('knowledgeTest/queryHistory', {});
  }
  static exportReport() {
    return useGet<IQueryByKnowledgeTestIdParams, KnowledgeTestExportReportResponse>('knowledgeTest/exportReport', {});
  }
}
